import React from 'react';
import img from '../../styles/edit.png';
import { Button } from '../common/Button';

// @ts-ignore
export default (onClickHandler, canDeactivate) => {
    return [
        {
            name: 'Name',
            id: 'name',
            // @ts-ignore
            selector: row => {
                return row.name.charAt(0).toUpperCase() + row.name.slice(1);
            },
            sortable: true
        },
        {
            name: 'Company',
            id: 'companyName',
            // @ts-ignore
            selector: row => {
                if(!row.companyName) return row.companyName
                return row.companyName.charAt(0).toUpperCase() + row.companyName.slice(1);
            },
            sortable: true
        },

        {
            name: 'Type',
            id: 'organisationsType',
            // @ts-ignore
            selector: row => row.organisationType,
            // @ts-ignore
            format: row => {
                return row.organisationType
            },
            sortable: true
        },
        {
            name: 'EmailAddress',
            id: 'emailAddress',
            // @ts-ignore
            selector: row => row.emailAddress,
            // @ts-ignore
            format: row => {
                return row.emailAddress ? row.emailAddress : '-'
            },
            sortable: true
        },
        {
            name: 'Function',
            id: 'function',
            // @ts-ignore
            selector: row => row.function,
            sortable: true,
        },
        {
            name: 'Language',
            id: 'locale',
            // @ts-ignore
            selector: row => row.locale,
            sortable: true,
        },
        {
            name: 'Phone no.',
            id: 'phoneNumber',
            // @ts-ignore
            selector: row => row.phoneNumber,
            sortable: true
        },
        {
            name: 'Deactivate',
            // @ts-ignore
            cell: (row, index, column, id) => {
                if(!canDeactivate) return <></>

                return <Button type="button" className="image" onClick={() => {
                    onClickHandler(row)
                }}><img src='/assets/cross-black.svg' width='35' height='35' alt='cross' /></Button>
            }
        },
    ];
}
